import { render, staticRenderFns } from "./textOneColumn.vue?vue&type=template&id=4543a2fc&"
import script from "./textOneColumn.vue?vue&type=script&lang=js&"
export * from "./textOneColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports